import type { Catalog } from '@smarton-pbx/shared';

/** Calls, a call's page, voicemail, contacts and the AI review. */
export const calls: Catalog = {
  // The call list (Calls.tsx).
  Incoming: 'Įeinantis',
  Outgoing: 'Išeinantis',
  Internal: 'Vidinis',
  'Today, {time}': 'Šiandien, {time}',
  'The phone in this browser isn’t connected': 'Telefonas šioje naršyklėje neprijungtas',
  'Call {name}': 'Skambinti: {name}',
  'Every call, with recordings and transcripts.': 'Visi skambučiai su įrašais ir transkripcijomis.',
  'Calls in your region, with recordings and transcripts.': 'Jūsų regiono skambučiai su įrašais ir transkripcijomis.',
  'A number, or words said in the call': 'Numeris arba pokalbyje pasakyti žodžiai',
  'Search calls': 'Ieškoti skambučių',
  Direction: 'Kryptis',
  'All directions': 'Visos kryptys',
  Outcome: 'Baigtis',
  'Any outcome': 'Bet kokia baigtis',
  Person: 'Darbuotojas',
  Everyone: 'Visi',
  'All regions': 'Visi regionai',
  From: 'Nuo',
  To: 'Iki',
  // The call list's heading (the plain text is a date range's end).
  'column|To': 'Kam',
  'column|Call': 'Skambutis',
  // The AI review's sales result (the plain text is how a call ended).
  'sale|Outcome': 'Rezultatas',
  'Reason: {name}': 'Priežastis: {name}',
  'chosen reason': 'pasirinkta priežastis',
  'Remove the reason filter': 'Pašalinti priežasties filtrą',
  Clear: 'Išvalyti',
  'No calls match': 'Atitinkančių skambučių nėra',
  'No calls yet': 'Skambučių dar nėra',
  'Try other filters or words.': 'Pabandykite kitus filtrus ar žodžius.',
  'Calls appear here as they happen.': 'Skambučiai čia atsiras, kai tik jie įvyks.',
  When: 'Laikas',
  Duration: 'Trukmė',
  'Recording and transcript': 'Įrašas ir transkripcija',
  Recording: 'Įrašas',
  Transcript: 'Transkripcija',
  '“{text}”': '„{text}“',
  'Loading…': 'Įkeliama…',

  // How a call ended: the outcome filter (lib/calls outcome() has the same words, in phone).
  Answered: 'Atsiliepta',
  Missed: 'Praleista',
  Busy: 'Užimta',
  Failed: 'Nepavyko',
  'Not allowed': 'Neleista',

  // A call's page (CallPage.tsx).
  'What was said': 'Kas pasakyta',
  'Nothing was said': 'Nieko nepasakyta',
  'Saving…': 'Saugoma…',
  Saved: 'Išsaugota',
  Staff: 'Darbuotojas',
  'Incoming call from {name}': 'Įeinantis skambutis – {name}',
  'Outgoing call with {name}': 'Išeinantis skambutis – {name}',
  'Internal call with {name}': 'Vidinis skambutis – {name}',
  'From {name}': 'Skambino {name}',
  'Save contact': 'Išsaugoti kontaktą',
  'New contact': 'Naujas kontaktas',
  Download: 'Atsisiųsti',
  'Plays from {time}.': 'Grojama nuo {time}.',
  'Every play is recorded in the audit log.': 'Kiekvienas perklausymas registruojamas veiksmų žurnale.',
  'Paused at {time} for {seconds} s': 'Pristabdyta ties {time}, {seconds} s',
  'Paused at {time} until the end': 'Pristabdyta ties {time} iki pabaigos',
  'Preparing the recording…': 'Įrašas ruošiamas…',
  'The recording could not be processed.': 'Įrašo nepavyko apdoroti.',
  'AI review': 'DI vertinimas',
  'Across {n} calls with this customer': {
    one: 'Per {n} skambutį su šiuo klientu',
    few: 'Per {n} skambučius su šiuo klientu',
    other: 'Per {n} skambučių su šiuo klientu',
  },
  '({percent}% sure)': '({percent}% tikimybė)',
  'took {time}': 'užtruko {time}',
  '({ratio}× the call)': '({ratio}× skambučio trukmės)',
  'Checked by {name}': 'Patikrino {name}',
  Checked: 'Patikrinta',
  Correct: 'Taisyti',
  "Every line is right now: the ones you didn't change count as checked too": 'Visos eilutės dabar teisingos: nekeistos eilutės taip pat laikomos patikrintomis',
  'Transcript checked': 'Transkripcija patikrinta',
  'With the current transcription settings, e.g. another model': 'Pagal dabartinius transkribavimo nustatymus, pvz., kitu modeliu',
  'Transcribe again': 'Transkribuoti iš naujo',
  'Transcribing… this can take a few minutes.': 'Transkribuojama… Tai gali užtrukti kelias minutes.',
  'This call wasn’t transcribed.': 'Šis skambutis nebuvo transkribuotas.',
  'Transcription failed. The recording is unaffected.': 'Transkribuoti nepavyko. Įrašui tai įtakos neturi.',
  'No speech was found in this call.': 'Šiame skambutyje kalbos nerasta.',
  'Fix the words; capitals and punctuation don’t matter. Each line is saved when you leave it. Click a name to hear the line.':
    'Pataisykite žodžius; didžiosios raidės ir skyrybos ženklai nesvarbūs. Eilutė išsaugoma, kai iš jos išeinate. Spustelėkite vardą, kad išgirstumėte eilutę.',
  'Your corrections also teach the transcription.': 'Jūsų pataisymai kartu moko transkribavimą.',
  'Machine transcript: it may contain mistakes. Click a line to hear it.': 'Automatinė transkripcija: joje gali būti klaidų. Spustelėkite eilutę, kad ją išgirstumėte.',
  'Play this line': 'Paleisti šią eilutę',
  'Personal details in this line are hidden from you. A manager or admin can correct it.':
    'Šios eilutės asmens duomenys nuo jūsų paslėpti. Ją gali pataisyti vadovas arba administratorius.',
  'The transcription wrote: “{text}”. Corrected by {name}, {when}.': 'Transkripcija buvo užrašiusi: „{text}“. Pataisė {name}, {when}.',
  'The transcription wrote: “{text}”. Corrected {when}.': 'Transkripcija buvo užrašiusi: „{text}“. Pataisyta {when}.',
  corrected: 'pataisyta',
  '(nothing said)': '(nieko nepasakyta)',

  // Voicemail (Voicemail.tsx).
  'Writing down the message…': 'Žinutė užrašoma…',
  'Message from {name}': 'Žinutė, kurią paliko {name}',
  'Messages left when nobody answered your number.': 'Žinutės, kurias skambinantieji paliko, kai niekas neatsiliepė.',
  'No messages': 'Žinučių nėra',
  'When a caller leaves a message, it appears here.': 'Kai skambinantysis palieka žinutę, ji atsiranda čia.',
  New: 'Nauja',
  'Put the number in the dialer': 'Įrašyti numerį į klaviatūrą',

  // Contacts (contacts.tsx); Company, Call {name} and Delete {name}? also on the pipeline's lead panel.
  'Customers and others your team talks to: their numbers, notes, and every call with them and what it was about.':
    'Klientai ir kiti žmonės, su kuriais kalba jūsų komanda: jų numeriai, pastabos ir visi skambučiai su jais bei apie ką jie buvo.',
  'Name, company, email or number': 'Vardas, įmonė, el. paštas ar numeris',
  'Search contacts': 'Ieškoti kontaktų',
  'No contact matches': 'Atitinkančių kontaktų nėra',
  'No contacts yet': 'Kontaktų dar nėra',
  'Add one here, or save a caller from a call.': 'Pridėkite kontaktą čia arba išsaugokite skambinantįjį iš skambučio.',
  'Last call': 'Paskutinis skambutis',
  'Delete {name}? Their calls stay.': 'Ištrinti „{name}“? Skambučiai istorijoje liks.',
  'Card by {name}': 'Kortelės autorius: {name}',
  'Delete contact': 'Ištrinti kontaktą',
  'No numbers yet.': 'Numerių dar nėra.',
  'None yet. Edit the card to add what the team should know.': 'Pastabų dar nėra. Redaguokite kortelę ir įrašykite, ką turėtų žinoti komanda.',
  'No calls with these numbers yet.': 'Šiais numeriais skambučių dar nebuvo.',
  'Edit {name}': 'Redaguoti: {name}',
  'Summary on its way': 'Santrauka ruošiama',
  Company: 'Įmonė',
  'Mobile, office…': 'Mobilusis, darbo…',
  'What number it is': 'Koks tai numeris',
  'Remove number': 'Pašalinti numerį',
  'What the team should know: what they bought, how they like to be contacted…': 'Ką turėtų žinoti komanda: ką klientas pirko, kaip jis nori, kad su juo būtų susisiekta…',

  // The AI review (Review.tsx).
  'Sales call': 'Pardavimo skambutis',
  'Support call': 'Pagalbos skambutis',
  'Between colleagues': 'Tarp kolegų',
  'Not a conversation': 'Ne pokalbis',
  'Calls between colleagues aren’t reviewed.': 'Skambučiai tarp kolegų nevertinami.',
  'Nobody answered, so there was nothing to review.': 'Niekas neatsiliepė, todėl nebuvo ko vertinti.',
  'The call was too short to review.': 'Skambutis buvo per trumpas, kad jį būtų galima įvertinti.',
  'No speech was found in the call.': 'Skambutyje kalbos nerasta.',
  'This month’s AI budget is used up; reviews start again next month.': 'Šio mėnesio DI biudžetas išnaudotas; vertinimai vėl prasidės kitą mėnesį.',
  'AI reviews were turned off before this call was reviewed.': 'DI vertinimai buvo išjungti anksčiau, nei šis skambutis buvo įvertintas.',
  'Play this moment': 'Paleisti šią vietą',
  'Open that call at this moment': 'Atidaryti tą skambutį šioje vietoje',
  'What is wrong with it? (optional)': 'Kas su juo negerai? (neprivaloma)',
  Corrected: 'Pataisyta',
  'Handled: {detail}': 'Kaip atsakyta: {detail}',
  'Marked as wrong': 'Pažymėta kaip klaidinga',
  'Tell us this point is wrong': 'Pažymėti, kad šis punktas klaidingas',
  'Wrong?': 'Klaidinga?',
  'Correct the reasons': 'Taisyti priežastis',
  'Save reasons': 'Išsaugoti priežastis',
  'Reviewing the call…': 'Skambutis vertinamas…',
  'Not reviewed.': 'Neįvertinta.',
  'The review failed. The call and its transcript are unaffected.': 'Įvertinti nepavyko. Skambučiui ir jo transkripcijai tai įtakos neturi.',
  'Only sales calls get a full review.': 'Išsamiai vertinami tik pardavimo skambučiai.',
  'Corrected by a person. The AI said: {outcome}.': 'Pataisė žmogus. DI buvo nurodęs: {outcome}.',
  'The AI’s guess. Correct it if it’s wrong: corrections always count.': 'DI spėjimas. Jei jis klaidingas, pataisykite: pataisymai visada įskaičiuojami.',
  Scorecard: 'Vertinimo kortelė',
  'For coaching, not grading.': 'Skirta mokymui, ne vertinimui.',
  'The AI wasn’t sure about': 'Dėl ko DI abejojo',
  'Written by AI ({model}) from a machine transcript: it can be wrong.': 'Parašė DI ({model}) pagal automatinę transkripciją: gali būti klaidų.',
  'Personal data was hidden before the transcript was sent.': 'Prieš siunčiant transkripciją asmens duomenys buvo paslėpti.',
  'Review the call again, e.g. after the scorecard changed': 'Įvertinti skambutį iš naujo, pvz., pasikeitus vertinimo kortelei',
  'Review again': 'Įvertinti iš naujo',
  Talk: 'Pokalbis',
  'Counted from the transcript': 'Apskaičiuota pagal transkripciją',
  '{name} talked {percent}% of the time': '{name} kalbėjo {percent}% laiko',
  'Other side {percent}%': 'Kita pusė {percent}%',
  'Longest monologue': 'Ilgiausias monologas',
  'Questions asked': 'Užduoti klausimai',
  Interruptions: 'Pertraukimai',
  '{name} / the other side.': '{name} / kita pusė.',
  // The sales review type's outcomes and sections (the API sends them in English: apps/api/review-types/sales-v1.json).
  'Sale agreed': 'Susitarta dėl pardavimo',
  'Follow-up agreed': 'Susitarta dėl tolesnių veiksmų',
  'No sale': 'Pardavimas neįvyko',
  'Not a sales conversation': 'Ne pardavimo pokalbis',
  "Why the sale didn't go through": 'Kodėl pardavimas neįvyko',
  'What the customer needs': 'Ko reikia klientui',
  'Competitors named': 'Paminėti konkurentai',
  Objections: 'Prieštaravimai',
  'What went well': 'Kas pavyko',
  'To do differently next time': 'Ką kitą kartą daryti kitaip',
  'Next steps and promises': 'Tolesni veiksmai ir pažadai',
};
